const EBAY_AUTH_URL = import.meta.env.VITE_EBAY_AUTH_URL as string;

export default function AuthorizePage() {
  const handleAuthorize = () => {
    window.location.href = EBAY_AUTH_URL;
  };

  return (
    <div className="min-h-screen bg-[#F9FAFB] flex items-center justify-center p-4 font-sans">
      <button
        onClick={handleAuthorize}
        className="px-10 py-4 rounded-xl font-medium text-white bg-blue-600 hover:bg-blue-700 transition-colors shadow-md shadow-blue-200 cursor-pointer text-base"
      >
        Authorize
      </button>
    </div>
  );
}
